import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../utils/axios.ts';
import { toast } from 'react-hot-toast';
import getApiErrorMessage from '../utils/helper.js';

export interface ReapplyLoanData {
  reapply_from_loan_id: number;
  loan_type_id: number;
  principal: number;
  top_up_amount: number;
  reapply_reason?: string;
  start_date: string;
  reason: string;
}

export interface EligibleReapplyLoan {
  id: number;
  loan_no: string;
  principal: number;
  loan_balance: number;
  total_amount: number;
  monthly_installments: number;
  start_date: string;
  end_date: string;
  status: string;
  member: {
    id: number;
    name: string;
  };
  loan_type: {
    id: number;
    name: string;
  };
}

export const useEligibleReapplyLoans = (memberId?: number) => {
  return useQuery({
    queryKey: ['eligible-reapply-loans', memberId],
    queryFn: async () => {
      if (!memberId) return [];
      const { data } = await api.get(`/memberloan/eligible-reapply?member_id=${memberId}`);
      return data.data || [];
    },
    enabled: !!memberId,
  });
};

export const useReapplyLoan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (reapplyData: ReapplyLoanData) => {
      const { data } = await api.post('/memberloan/reapply', reapplyData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['member-loans'] });
      queryClient.invalidateQueries({ queryKey: ['eligible-reapply-loans'] });
      toast.success('Reapply loan created successfully');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}; 